import React from "react";
import { Spin } from "antd";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import CandidateCard from "./CandidateCard";

interface Candidate {
    id: string;
    name: string;
    // Other fields of candidate can go here
}

interface SearchResultListProps {
    searchResult: any;
    handleSelectCandidate: (candidateId: string) => void;
    selectedCandidates: string[];
    defaultSelectedProject: { id: string };
}


const SearchResultList = ({
    searchResult,
    handleSelectCandidate,
    selectedCandidates,
    selectedPool,
    searchId,
    page,
    setPage,
    candidateList,
    setCandidateList,
    loadMoreDataFunctionCall,
    searchResultStat,
    candidateLoading,
    loadMoreData,
    handleShortlistCandidate,
    handleRejectCandidate
}: any) => {
    
    return (
        <>
            <InfiniteScroll
                scrollableTarget="scrollableDiv"
                dataLength={candidateList?.length}
                next={loadMoreData}
                hasMore={searchResultStat.total_pages >= page}
                loader={
                    <div className="flex justify-center p-4 items-center">
                        <Spin size="small" />
                    </div>
                }
            >
                {candidateList?.map((candidate: any) => (
                    <CandidateCard
                        key={candidate.id}
                        candidateDetails={candidate}
                        handleSelectCandidate={handleSelectCandidate}
                        selectedCandidates={selectedCandidates}
                        shortList={true}
                        notes={false}
                        isSearch={true}
                        searchId={searchId}
                        selectedPool={selectedPool}
                        handleShortlistCandidate={handleShortlistCandidate}
                        handleRejectCandidate={handleRejectCandidate}
                    />
                ))}
            </InfiniteScroll>

        </>
    );
};

export default SearchResultList;
